// src/services/errorLoggingService.js
import { db, auth } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

class ErrorLoggingService {
  /**
   * Log error to Firebase Firestore
   * @param {Error} error - The error object
   * @param {Object} errorInfo - Additional error information
   */
  async logError(error, errorInfo = {}) {
    try {
      const user = auth.currentUser;

      // Prepare error data
      const errorData = {
        // Error details
        message: error.message || 'Unknown error',
        stack: error.stack || 'No stack trace',
        name: error.name || 'Error',

        // User info (if logged in)
        userId: user?.uid || 'anonymous',
        userEmail: user?.email || 'not logged in',

        // Context info
        componentStack: errorInfo.componentStack || 'N/A',
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: serverTimestamp(),

        // Device info
        platform: navigator.platform,
        language: navigator.language,
        screenResolution: `${window.screen.width}x${window.screen.height}`,

        // App state
        isOnline: navigator.onLine,
      };

      // Save to Firestore 'errorLogs' collection
      await addDoc(collection(db, 'errorLogs'), errorData);

      console.log('Error logged to Firebase:', errorData.message);
    } catch (loggingError) {
      // Don't let logging errors break the app
      console.error('Failed to log error to Firebase:', loggingError);
    }
  }
}

export default new ErrorLoggingService();